import { useQuery } from "@apollo/client";
import {
  getAccountTemplatesCountQuery,
  getSchoolTranscriptTemplatesQuery,
} from "../modules/queries";
import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { useTranscriptsContext } from "TranscriptsV3/context/TranscriptsContext";

const useSchoolTemplates = id => {
  const { accountProgramId, isSchoolPortalRoute } = useTranscriptsContext();

  const { data, networkStatus } = useQuery(getSchoolTranscriptTemplatesQuery, {
    variables: { id },
    fetchPolicy: "cache-and-network",
    skip: !id,
  });

  const { data: accountTemplatesData } = useQuery(
    getAccountTemplatesCountQuery,
    {
      variables: { id: accountProgramId },
      fetchPolicy: "cache-and-network",
      skip: isSchoolPortalRoute,
    }
  );

  const templates = useMemo(
    () =>
      _.chain(data).get("node.transcriptTemplates.edges").map("node").value(),
    [data]
  );

  const [templateId, setTemplateId] = useState(() =>
    _.get(templates, "[0].id", null)
  );

  const selectedTemplate = useMemo(() => {
    return _.find(templates, { id: templateId });
  }, [templateId, templates]);

  const accountTemplatesCount = _.get(
    accountTemplatesData,
    "node.transcriptTemplates.totalCount",
    0
  );

  useEffect(() => {
    setTemplateId(prev => {
      if (prev && _.find(templates, { id: prev })) {
        return prev;
      }

      return _.get(templates, "[0].id", null);
    });
  }, [templates]);

  return {
    templates,
    isLoading: _.isEmpty(data) && _.includes([1, 2], networkStatus),
    selectedTemplate,
    setTemplateId,
    templateId,
    accountTemplatesCount,
  };
};

export default useSchoolTemplates;
